import { isSafari } from "../components/global";

export class Speech {
    private synthesis: SpeechSynthesis;
    private hasSpeech = false;

    constructor() {
        if (!window.speechSynthesis) {
            console.error("Speech synthesis not supported in this browser.");
        }
        this.synthesis = window.speechSynthesis;
    }

    // Speak with a specific voice by voice name
    public async speak(
        text: string,
        callback: () => void,
        voiceName: string = isSafari ? "Samantha" : "Google US English",
        rate: number = 1,
        pitch: number = 1
    ): Promise<void> {
        if (this.hasSpeech) {
            this.resume();
            return;
        } else {
            this.stop(); // needed to replay
        }

        const voices = await this.voices();
        const utterance = new SpeechSynthesisUtterance(text);
        const selectedVoice = voices.find((voice) => voice.name === voiceName);

        // console.log(
        //     "Available voices: ",
        //     voices.map((voice) => voice.name)
        // );

        if (!selectedVoice) {
            console.error(
                `Voice "${voiceName}" not found. Using default voice.`
            );
            // Fallback to the first available voice
            utterance.voice = voices[0] || null;
            utterance.lang = voices[0]?.lang || "en-US";
        } else {
            utterance.voice = selectedVoice;
            utterance.lang = selectedVoice.lang;
        }

        utterance.rate = rate;
        utterance.pitch = pitch;
        utterance.volume = 1;

        utterance.onstart = () => {
            this.hasSpeech = true;
            // console.log(
            //     `Speech started with voice: ${selectedVoice?.name || "default"}`
            // );
        };
        utterance.onpause = () => {};
        utterance.onresume = () => {};
        utterance.onend = () => {
            this.hasSpeech = false;
            //this.stop();
            callback();
        };
        utterance.onerror = (event) =>
            console.error("Speech error: ", event.error);

        this.synthesis.speak(utterance);
    }

    // Pause ongoing speech
    public pause(): void {
        if (this.synthesis) {
            this.synthesis.pause();
        }
    }

    // Resume paused speech
    private resume(): void {
        if (this.synthesis) {
            this.synthesis.resume();
        }
    }

    // Stop any ongoing speech
    private stop(): void {
        if (this.synthesis) {
            this.synthesis.cancel();
        }
    }

    // List available voices
    private voices(): Promise<SpeechSynthesisVoice[]> {
        return new Promise((resolve) => {
            // if (!this.synthesis) {
            //     console.error("Speech synthesis not available.");
            //     resolve([]);
            //     return;
            // }

            const voices = this.synthesis.getVoices();
            if (voices.length > 0) {
                resolve(voices);
            } else {
                // Wait for voices to load asynchronously
                this.synthesis.onvoiceschanged = () => {
                    resolve(this.synthesis.getVoices());
                };
            }
        });
    }

    // // Read text aloud with customizable language, rate, and pitch
    // public speak(
    //     text: string,
    //     lang: string = "en-US",
    //     rate: number = 1,
    //     pitch: number = 1
    // ): void {
    //     // if (!this.synthesis) {
    //     //     console.error("Speech synthesis not available.");
    //     //     return;
    //     // }

    //     const utterance = new SpeechSynthesisUtterance(text);
    //     utterance.lang = lang;
    //     utterance.rate = rate;
    //     utterance.pitch = pitch;
    //     utterance.volume = 1;

    //     // Event handlers
    //     utterance.onstart = () => console.log("Speech started");
    //     utterance.onend = () => console.log("Speech ended");
    //     utterance.onerror = (event) =>
    //         console.error("Speech error: ", event.error);

    //     this.synthesis.speak(utterance);
    // }
}
